import { parse } from 'query-string';

export const getPageFromQuery = (query: string) => {
  const { page } = parse(query);
  return typeof page === 'string' && !isNaN(+page) ? +page : 1;
};
